import { render, staticRenderFns } from "./WorkflowProcessListPane.vue?vue&type=template&id=52ece082&scoped=true"
import script from "./WorkflowProcessListPane.vue?vue&type=script&lang=js"
export * from "./WorkflowProcessListPane.vue?vue&type=script&lang=js"
import style0 from "./WorkflowProcessListPane.vue?vue&type=style&index=0&id=52ece082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ece082",
  null
  
)

export default component.exports